/* eslint-disable jsdoc/require-description-complete-sentence */
/**
 * @module validators
 */

/**
 * Convenience function to return a class name string value for the provided
 * value. The function checks to ensure the provided value is a legitimate type
 * string, additionally that does not have a value of a known falsy or boolean
 * value (e.g. 'true' is not seen as a valid value for a class name).
 *
 * @param {*} value - The value to convert and return as class name string.
 *
 * @returns {string} Class name string of the provided value, or a blank string if the provided value is falsy.
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Glossary/Falsy}.
 */
function convertValueToClassName(value) {
  const falsyValues = [
    undefined,
    'undefined',
    null,
    'null',
    false,
    'false',
    true,
    'true',
    NaN,
    0n,
    0,
    -0,
  ];
  return typeof value === 'string' && !falsyValues.includes(value)
    ? value.trim()
    : '';
}

module.exports = {
  convertValueToClassName,
};
